// When a shopper picks another size (e.g. 10ml), slide the product gallery to that size's own photo.
// The product form is re-rendered on every size change; it carries the chosen size's photo id.
const form = document.querySelector('[data-product-form]');
const track = document.querySelector('[data-product-gallery]');
if (form && track) {
  let lastId = form.querySelector('[data-variant-media-id]')?.dataset.variantMediaId || '';
  const goTo = (id) => {
    const slide = id && track.querySelector(`[data-media-id="${id}"]`);
    if (!slide) return;
    const left = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
    track.scrollTo({ left, behavior: 'smooth' });
  };
  new MutationObserver(() => {
    const id = form.querySelector('[data-variant-media-id]')?.dataset.variantMediaId || '';
    if (id && id !== lastId) {
      lastId = id;
      goTo(id);
    }
  }).observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-variant-media-id'] });
  // Deep links such as ?variant=… open on that size's photo.
  if (new URL(location.href).searchParams.has('variant')) goTo(lastId);
}

// Backup: after any size tap, re-check once the new price and form have loaded.
if (form && track) {
  form.addEventListener('change', () => {
    const check = (tries) => {
      const id = form.querySelector('[data-variant-media-id]')?.dataset.variantMediaId || '';
      const slide = id && track.querySelector(`[data-media-id="${id}"]`);
      if (slide && Math.abs(slide.getBoundingClientRect().left - track.getBoundingClientRect().left) > 4) {
        const left = track.scrollLeft + slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left, behavior: 'smooth' });
      } else if (tries > 0) {
        setTimeout(() => check(tries - 1), 250);
      }
    };
    setTimeout(() => check(8), 250);
  });
}
